import { render } from "./MenusPage.vue?vue&type=template&id=42eff10a&scoped=true"
import script from "./MenusPage.vue?vue&type=script&lang=js"
export * from "./MenusPage.vue?vue&type=script&lang=js"

import "./MenusPage.vue?vue&type=style&index=0&id=42eff10a&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-76db364fbb/3/buildhome/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42eff10a"]])

export default __exports__